module.exports = __webpack_public_path__ + "static/media/Luis.d8c693aa.jpg";